export default "__VITE_ASSET__BuvHuqRy__"